export class GetLocationSearchFilterResponse {
    serviceList: string[] = [];
    typeList: string[] = [];
}

export class LocationSearchFilters {

    constructor(providerSearchFilterResponse: GetLocationSearchFilterResponse) {
        this.serviceList = providerSearchFilterResponse.serviceList.map(value => {
            const filter = new SearchFilter()
            filter.value = value;
            filter.isSelected = false;
            return filter;
        });
        
        this.typeList = providerSearchFilterResponse.typeList.map(value => {
            const filter = new SearchFilter()
            filter.value = value;
            filter.isSelected = false;
            return filter;
        });
    }

    facilityOrLocationName: string = '';
    serviceList: SearchFilter[] = [];
    typeList: SearchFilter[] = [];
    location: string = '';
    distanceInMiles: number = 15;
}

export class SearchFilter {
    value: string = '';
    isSelected: boolean = false;
}